import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformClientResponse } from 'helpers/core';
import URLS from 'constants/urls';
import { VENUE_FEATURE_PROBE_HTTP_CONFIG } from 'helpers/session-auth-http';

const handler = ({ httpClient }, venueId) => {
  const endpoint = URLS.instructors.list(venueId);

  return httpClient.get(endpoint, VENUE_FEATURE_PROBE_HTTP_CONFIG).then(transformClientResponse);
};

export default makeEntityScaffold('SAGA.API.FETCH_INSTRUCTORS', handler, { defaultKey: 1 });
